import { makeStyles, mergeClasses } from "@fluentui/react-components";
import React from "react";
import { AmdDonutChart } from "../../../../components/common/charts/DonutChart/DonutChart";
import { labelStyles } from "../../../../styles/commonStyles";
import { DonutLegendSection } from "../../../shared/components/airport-cards/shared/DonutLegendSection";
import PaxSecurityTooltip from "./PaxSecurityTooltip";

interface IDonutItem {
  label: string;
  resourceData: any;
}

interface IPaxSecurityChartsProps {
  legendItems: { resourceTitle: string; resourceColor: string }[];
  donuts: [IDonutItem, IDonutItem];
}

const renderPaxTooltip = (label: string) => (dataPoint: any) => {
  if (dataPoint.legend === "Threshold") {
    return null;
  }
  return <PaxSecurityTooltip dataPoint={dataPoint} label={label} />;
};

const PaxSecurityCharts: React.FunctionComponent<IPaxSecurityChartsProps> = ({
  legendItems,
  donuts,
}): React.JSX.Element => {
  const classes = useStyles();
  const labelClasses = labelStyles();

  const tooltipRenderers = donuts.map((donut) => renderPaxTooltip(donut.label));

  return (
    <article className={classes.rowContainer} data-testid="pax-security-charts">
      <div className={classes.legendSection}>
        {legendItems.map((item) => (
          <DonutLegendSection
            key={`legend-${item.resourceTitle}`}
            resourceTitle={item.resourceTitle}
            resourceColor={item.resourceColor}
          />
        ))}
      </div>

      <div className={classes.chartsContainer}>
        {donuts.map((donut, index) => (
          <div key={`donut-${donut.label}`} className={classes.donutSection}>
            <span
              className={mergeClasses(
                classes.donutLabel,
                labelClasses.overViewLabel
              )}
            >
              {donut.label}
            </span>
            <div className={classes.chartClip}>
              <AmdDonutChart
                resourceData={donut.resourceData}
                noFlightsMessage={`No ${donut.label} found`}
                hideLegend={true}
                showCustomLegend={true}
                radius={40}
                width={80}
                height={75}
                fontSize={"16px"}
                showPercent={donut.label === "Z2 Capacity" ? true : false}
                customTooltip={tooltipRenderers[index]}
              />
            </div>
          </div>
        ))}
      </div>
    </article>
  );
};

export default PaxSecurityCharts;

const useStyles = makeStyles({
  rowContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-evenly",
  },
  legendSection: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    gap: "4px",
    lineHeight: "1.5",
    paddingTop: "20px",
    whiteSpace: "nowrap",
    flexShrink: "1",
  },
  chartsContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: "20px",
    flexShrink: "0",
    paddingRight: "16px",
  },
  chartClip: {
    width: "80px",
    height: "90px",
    overflow: "hidden",
    flexShrink: "0",
  },
  donutLabel: {
    textAlign: "center",
    lineHeight: "1",
  },
  donutSection: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    flexShrink: "0",
    overflow: "hidden",
  },
});
